/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../../../components/ui-elements/table/StyledTableRow';
import { IconButton, Typography } from '@mui/material';
import { BsFillPencilFill } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import DialogContainer from '../../../../../../../components/shared/Dialog/DialogContainer';
import { FaHistory } from 'react-icons/fa';
import OrgAuthProviderHistory from './OrgAuthProviderHistory';
import OrgAuthProviderEdit from './OrgAuthProviderEdit';

const OrgAuthProvidersList = () => {
    const [selectedOrgAuthProvider, setSelectedOrgAuthProvider] = useState({});
    const [openEditOrgAuthProviders, setopenEditOrgAuthProviders] = useState(false);
    const [openHistoryOrgAuthProviders, setopenHistoryOrgAuthProviders] = useState(false);
    const orgAuthProvider = useSelector(state => state.orgAuthProvider.orgAuthProvider);

    const handleCloseDialog = () => {
        setopenEditOrgAuthProviders(false);
        setopenHistoryOrgAuthProviders(false);
    }
    return (
        <><TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                    <StyledTableRow>
                        <StyledTableCell label="Identity Provider Name" />
                        <StyledTableCell label="Organization Name" />
                        <StyledTableCell label="Details" />
                        <StyledTableCell label=" " />

                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    {orgAuthProvider?.Records?.length > 0 && orgAuthProvider.Records.map((row) => (
                        <StyledTableRow key={row.authProviderName}>
                            <StyledTableCell label={row.authProviderName} />
                            <StyledTableCell label={row.organizationName} />
                            <StyledTableCell   >
                                {row.organizationAuthProviderDetails.length > 0 ?
                                    <Typography style={{ fontWeight: 'bold' }} color={row.organizationAuthProviderDetails[0].detailValue === "true" ? 'primary' : 'error'}>
                                        {row.organizationAuthProviderDetails[0].detailValue === "true" ? 'Authorized' : 'Unauthorized'}
                                    </Typography> : "N/A"}
                            </StyledTableCell>

                            <StyledTableCell align="right"  >
                                <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedOrgAuthProvider(row); setopenEditOrgAuthProviders(true) }}>
                                    <BsFillPencilFill />
                                </IconButton>
                                <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedOrgAuthProvider(row); setopenHistoryOrgAuthProviders(true) }}>
                                    <FaHistory />
                                </IconButton>
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>


            <DialogContainer
                open={openEditOrgAuthProviders}
                handleClose={handleCloseDialog}
            >
                <OrgAuthProviderEdit
                    selectedOrgAuthProvider={selectedOrgAuthProvider}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
            <DialogContainer
                open={openHistoryOrgAuthProviders}
                handleClose={handleCloseDialog}
            >
                <OrgAuthProviderHistory
                    selectedOrgAuthProvider={selectedOrgAuthProvider}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}



export default OrgAuthProvidersList;
